<template>
    <transition name="fade">
      <span v-if="visible" class="saved-message" :class="messageClass">{{ message }}</span>
    </transition>
  </template>

  <script>
  export default {
    name: "SavedMessage",
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      success: {
        type: Boolean,
        default: true,
      },
      message: {
        type: String,
        default: null,
      },
    },
    computed: {
      messageClass() {
        return this.success ? 'success' : 'error';
      },
    },
  };
  </script>
  
  <style scoped>
  .saved-message {
    position: absolute;
    bottom: 100%;
    right: 0;
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  }

  .saved-message.success {
    color: #155724;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
  }

  .saved-message.error {
    color: #721c24;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }
  </style>
  